import { createFileRoute } from '@tanstack/react-router';

import { CAPABILITY_KEYS } from '@brightlocal/shared';

import { requireCustomerCapability } from 'shared/modules/capabilities';
import { routes } from 'shared/routes';

import { AddLocationPrompts, addLocationPromptsSearchSchema } from 'features/locations/AddLocation/AddLocationPrompts';

export const Route = createFileRoute('/_authenticated/locations/add/prompts/')({
  beforeLoad: ({ context, location }) =>
    requireCustomerCapability({
      queryClient: context.queryClient,
      key: CAPABILITY_KEYS.AI_VISIBILITY,
      fallbackRoute: routes.locations(),
      attemptedHref: location.href
    }),
  component: AddLocationPromptsRoute,
  validateSearch: addLocationPromptsSearchSchema
});

function AddLocationPromptsRoute() {
  const { locationId, placeId } = Route.useSearch();

  return <AddLocationPrompts locationId={locationId} placeId={placeId} />;
}
